import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

export const useUsersStore
    = defineStore('usersStore', () => {

    const usersEndpoint = environment.appConfig.baseApiUrl + "profile";
    const emailSubscriptionEndpoint = usersEndpoint + "/email-subscription";

    const crud = useCrudStore(usersEndpoint);


    async function updateUser({first_name, last_name, email, phone}) {
        console.log("updateUser", first_name, last_name, email, phone);
        crud.startLoading();
        try {
            const params = {first_name, last_name, email, phone};
            const resp = await httpClient.post(usersEndpoint, params);
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
        }catch (e){
            crud.setError(e);
        }
    }

    async function uploadUserImage(file) {
        crud.startLoading();
        try {
            const body = new FormData();
            body.append('image', file);
            const resp = await httpClient.post(usersEndpoint + "/image", body);
            if (resp.data?.status === 'error') {
                crud.setError(resp.data.message);
                return false;
            }
            crud.clearLoading();
            return true;
        } catch (e) {
            crud.setError(e);
            return false;
        }
    }

    async function updateEmailSubscription(emailSubscribed) {
        crud.startLoading();
        try {
            const resp = await httpClient.patch(emailSubscriptionEndpoint, {email_subscribed: emailSubscribed});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return null;
            }
            crud.clearLoading();
            return resp.data.user;
        } catch (e) {
            crud.setError(e);
            return null;
        }
    }

    return {
        ...crud,
        updateUser,
        updateEmailSubscription,
        uploadUserImage
    }
});
